import React from 'react';
import Button from 'components/ui/Button';
import Icon from 'components/AppIcon';

const ContactInfo = () => {
  const contactDetails = [
    {
      icon: 'Phone',
      title: 'Phone Numbers',
      items: [
        { label: 'Reception & Bookings', value: '+91 98765 43210', action: 'tel:+919876543210' },
        { label: 'Activities Desk', value: '+91 98765 43211', action: 'tel:+919876543211' },
        { label: 'Emergency Contact', value: '+91 98765 43212', action: 'tel:+919876543212' }
      ]
    },
    {
      icon: 'Mail',
      title: 'Email Addresses',
      items: [
        { label: 'General Inquiries', value: 'info@dandeliadventure.com', action: 'mailto:info@dandeliadventure.com' },
        { label: 'Bookings', value: 'bookings@dandeliadventure.com', action: 'mailto:bookings@dandeliadventure.com' },
        { label: 'Activities', value: 'activities@dandeliadventure.com', action: 'mailto:activities@dandeliadventure.com' }
      ]
    },
    {
      icon: 'MapPin',
      title: 'Resort Address',
      items: [
        { 
          label: 'Physical Location', 
          value: `Dandeli Adventure Resorts\nKali River Road, Near Syntheri Rocks\nDandeli, Karnataka 581325\nIndia`,
          multiline: true
        }
      ]
    }
  ];

  const socialLinks = [
    { name: 'WhatsApp', icon: 'MessageCircle', color: 'bg-[#25D366]', action: 'https://wa.me/919876543210' },
    { name: 'Facebook', icon: 'Facebook', color: 'bg-[#1877F2]', action: 'https://facebook.com/dandeliadventure' },
    { name: 'Instagram', icon: 'Instagram', color: 'bg-gradient-to-r from-purple-500 to-pink-500', action: 'https://instagram.com/dandeliadventure' },
    { name: 'Twitter', icon: 'Twitter', color: 'bg-[#1DA1F2]', action: 'https://twitter.com/dandeliadventure' }
  ];

  const operatingHours = [
    { day: 'Monday - Friday', hours: '8:00 AM - 10:00 PM' },
    { day: 'Saturday - Sunday', hours: '7:00 AM - 11:00 PM' },
    { day: 'Check-in', hours: '2:00 PM onwards' },
    { day: 'Check-out', hours: '11:00 AM' }
  ];

  const handleContactClick = (action) => {
    if (action?.startsWith('tel:') || action?.startsWith('mailto:')) {
      window.location.href = action;
    } else {
      window.open(action, '_blank');
    }
  };

  return (
    <div className="space-y-6">
      {/* Contact Details */}
      {contactDetails?.map((section, index) => (
        <div key={index} className="bg-card rounded-lg shadow-organic p-6">
          <div className="flex items-center space-x-3 mb-4">
            <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
              <Icon name={section?.icon} size={20} className="text-primary" />
            </div>
            <h3 className="text-lg font-heading font-semibold text-card-foreground">
              {section?.title}
            </h3>
          </div>

          <div className="space-y-3">
            {section?.items?.map((item, itemIndex) => (
              <div key={itemIndex} className="flex flex-col space-y-1">
                <span className="text-sm font-medium text-muted-foreground">
                  {item?.label}
                </span>
                {item?.multiline ? (
                  <div className="text-card-foreground whitespace-pre-line">
                    {item?.value}
                  </div>
                ) : (
                  <button
                    onClick={() => item?.action && handleContactClick(item?.action)}
                    className={`text-left text-card-foreground ${
                      item?.action ? 'hover:text-primary transition-micro cursor-pointer' : ''
                    }`}
                  >
                    {item?.value}
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
      {/* Operating Hours */}
      <div className="bg-card rounded-lg shadow-organic p-6">
        <div className="flex items-center space-x-3 mb-4">
          <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
            <Icon name="Clock" size={20} className="text-primary" />
          </div>
          <h3 className="text-lg font-heading font-semibold text-card-foreground">
            Operating Hours
          </h3>
        </div>

        <div className="space-y-3">
          {operatingHours?.map((schedule, index) => (
            <div key={index} className="flex justify-between items-center">
              <span className="text-muted-foreground">{schedule?.day}</span>
              <span className="font-medium text-card-foreground font-mono">
                {schedule?.hours}
              </span>
            </div>
          ))}
        </div>
      </div>
      {/* Social Media Links */}
      <div className="bg-card rounded-lg shadow-organic p-6">
        <div className="flex items-center space-x-3 mb-4">
          <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
            <Icon name="Share2" size={20} className="text-primary" />
          </div>
          <h3 className="text-lg font-heading font-semibold text-card-foreground">
            Connect With Us
          </h3>
        </div>

        <div className="grid grid-cols-2 gap-3">
          {socialLinks?.map((social, index) => (
            <Button
              key={index}
              variant="outline"
              size="default"
              onClick={() => handleContactClick(social?.action)}
              iconName={social?.icon}
              iconPosition="left"
              className="justify-start"
            >
              {social?.name}
            </Button>
          ))}
        </div>
      </div>
      {/* Quick Actions */}
      <div className="bg-card rounded-lg shadow-organic p-6">
        <h3 className="text-lg font-heading font-semibold text-card-foreground mb-4">
          Quick Actions
        </h3>
        
        <div className="space-y-3">
          <Button
            variant="default"
            size="default"
            fullWidth
            iconName="Calendar"
            iconPosition="left"
            onClick={() => window.location.href = '/booking-engine'}
          >
            Book Your Stay
          </Button>
          
          <Button
            variant="outline"
            size="default"
            fullWidth
            iconName="MessageCircle"
            iconPosition="left"
            onClick={() => handleContactClick('https://wa.me/919876543210?text=Hi! I would like to know more about Dandeli Adventure Resorts.')}
          >
            Chat on WhatsApp
          </Button>
          
          <Button
            variant="outline"
            size="default"
            fullWidth
            iconName="Phone"
            iconPosition="left"
            onClick={() => handleContactClick('tel:+919876543210')}
          >
            Call Now
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;